define('ordersDetailOrderPhrasesItemView',[
  'module',
  'marionette',
  'underscore',
  'settings',
  'template!ordersDetailOrderPhrasesItemView'
], function (
  Module,
  Marionette,
  _,
  Settings,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'phrase-view',
    tagName: 'div',

    events: {
      'click .remove': 'onRemove'
    },

    serializeData: function () {
      var data = {};
      data.code = this.model.get('code') || '';

      var internalName = this.model.get('internalName');
      if (internalName && typeof internalName === 'object') {
        var lang = Settings.get('lang') || 'en';
        if (internalName.values && internalName.values[lang]) {
          data.internalName = internalName.values[lang];
        } else if (internalName.values) {
          var keys = Object.keys(internalName.values);
          data.internalName = keys.length > 0 ? internalName.values[keys[0]] : '';
        } else {
          data.internalName = '';
        }
      } else {
        data.internalName = internalName || '';
      }

      return data;
    },

    onRemove: function (e) {
      e.preventDefault();
      e.stopPropagation();
      this.trigger('remove:phrase', this.model);
    }
  });
});

